export const desktopProcessErrorCodeText: { [key: string]: string } = {
    API_URL_NOT_WHITELISTED: '',
    BITTIUM_EXAMINATION_DURATION_CANNOT_BE_FOURTEEN_DAYS:
        'Deze recorder kan niet voor veertien dagen worden ingesteld. Kies een andere opnameduur.',
    FAILED_TO_CREATE_DESTINATION_DIR_DURING_DOWNLOAD:
        'Het uitlezen is niet gelukt. Probeer het opnieuw of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    FAILED_TO_DOWNLOAD_REC_FILES_FROM_HOLTER:
        'Het uitlezen is niet gelukt. Probeer het opnieuw of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    FAILED_TO_DOWNLOAD_XML_FILE_FROM_HOLTER:
        'Het uitlezen is niet gelukt. Probeer het opnieuw of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    FAILED_TO_FETCH_HOLTER_CONFIGURATION_DATA:
        'Het instellen van de recorder is niet gelukt, neem contact op met de Servicedesk (+31 (0) 20 600 00 60)',
    FAILED_TO_FIND_HOLTER_DRIVE:
        'Er is iets mis gegaan. Controleer of de recorder goed is aangesloten of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    FAILED_TO_GET_TOTAL_FILES_SIZE:
        'Het uitlezen is niet gelukt. Probeer het opnieuw of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    GOT_ERROR:
        'Er is iets mis gegaan. Controleer of de recorder goed is aangesloten of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    HOLTER_ALREADY_CONTAINS_RECORDING:
        'Deze recorder is al ingesteld. Gebruik een andere recorder of leeg deze recorder via het Recorder overzicht.',
    HOLTER_ALREADY_SET:
        'Deze recorder is al ingesteld. Gebruik een andere recorder of leeg deze recorder via het Recorder overzicht.',
    HOLTER_CONFIGURATION_DATA_INCOMPLETE:
        'Het instellen van de recorder is niet gelukt, neem contact op met de Servicedesk (+31 (0) 20 600 00 60)',
    HOLTER_DEVICE_ECGSTATS_DOES_NOT_CONTAIN_SERIALNUMBER:
        'Het instellen van de recorder is niet gelukt, neem contact op met de Servicedesk (+31 (0) 20 600 00 60)',
    HOLTER_DEVICE_HAS_NO_ECGSTATS_FILE:
        'Er is iets mis gegaan. Neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    HOLTER_MUST_BE_PLUGGED_IN_TO_CONFIGURE_DEVICE: 'Er is momenteel geen recorder aangesloten',
    HOLTER_MUST_BE_PLUGGED_IN_TO_READ_RESULTS: 'Er is momenteel geen recorder aangesloten',
    HOLTER_READ_RESULTS_FAILED_MISSING_EXPECTED_FILES:
        'Je hebt mogelijk net een recorder verwisseld. Ververs deze pagina om verder te gaan.',
    HOLTER_USAGE_ONLY_ON_WINDOWS: 'Je kunt de recorder alleen via een Windows computer instellen',
    MULTIPLE_RECORDERS_ATTACHED:
        'We zien dat er meer dan 1 recorder is aangesloten aan je computer. Sluit maximaal 1 recorder aan en probeer het opnieuw.',
    NO_HOLTER_PROCEDURE_PHASE_GIVEN:
        'Er is iets mis gegaan. Controleer of de recorder goed is aangesloten of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    NO_PREPARATION_VALUE_GIVEN:
        'Het uitlezen is niet gelukt. Probeer het opnieuw of neem contact op met de Servicedesk (+31 (0) 20 600 00 60).',
    NO_REC_FILES_ON_HOLTER: 'Je hebt de recorder goed ingesteld, maar er zijn geen ECG bestand(en)',
    PARAMS_NOT_VALID: '',
    UNEXPECTED_CONTENT_TYPE: '',
    WRITING_CONFIG_TO_HOLTER_FAILED:
        'Het instellen van de recorder is niet gelukt, neem contact op met de Servicedesk (+31 (0) 20 600 00 60)',
};
